import styled from '@emotion/styled';
import { Link } from 'react-scroll';
import { css, Flex } from 'theme-ui';
import {
  StAccordion,
  StAccordionItemButton,
  StAccordionItemPanel,
} from '../../shared-styled/blocks/AccordionBlocks';
import pxToRem from '../../utils/pixelsToRem';

export const Container = styled(Flex)(({ dark }) =>
  css({
    position: 'relative',
    height: 'max-content',
    flexDirection: 'column',
    padding: '38px 30px 18px 30px',
    background: dark ? 'TOCDarkBackground' : 'text',
    color: 'white',
    zIndex: '1',
  }),
);

export const Title = styled.h2(
  css({
    fontWeight: '800',
    fontSize: pxToRem(18),
    lineHeight: pxToRem(24),
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: 'focus',
    mb: '12px',
  }),
);

export const Separator = styled.p(
  css({
    width: '50px',
    borderBottom: '1px solid white',
    mb: '12px',
    marginBottom: 0,
  }),
);

export const Paragraph = styled.p(({ level, small }) =>
  css({
    fontWeight: level === 0 ? '500' : '300',
    lineHeight: pxToRem(24),
    fontSize: pxToRem(16),
    marginBottom: '0.75rem',
    marginTop: level === 0 ? '0.75rem' : '0',
    letterSpacing: '0.01em',
    paddingLeft: `${level * 1.5}em`,
    textTransform: small ? 'lowercase' : 'none',

    '&:hover': {
      color: 'focus',
    },

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  }),
);

export const TableAccordion = styled(StAccordion)(({ dark }) =>
  css({
    width: '100%',
    px: '40px',
    py: '28px',
    my: 0,
    background: dark ? 'TOCDarkBackground' : 'text',
  }),
);

export const TableAccordionItemButton = styled(StAccordionItemButton)(
  css({
    p: 0,
    border: 'none',
  }),
);

export const TableAccordionItemPanel = styled(StAccordionItemPanel)(
  css({
    p: 0,
  }),
);

export const TableAccordionSeparator = styled.p(
  css({
    width: '50px',
    borderBottom: '1px solid white',
    my: '30px',
  }),
);

export const AnchorLink = styled(Link)(
  css({
    cursor: 'pointer',
  }),
);
